import { render, staticRenderFns } from "./CheckupDate.vue?vue&type=template&id=5f5f1d78&scoped=true"
import script from "./CheckupDate.vue?vue&type=script&lang=js"
export * from "./CheckupDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f1d78",
  null
  
)

export default component.exports